import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const decodedToken = jwtDecode(token);
      setUserRole(decodedToken.role); // Assuming the role is stored in the token under 'role'
    }
  }, []);

  return (
    <UserContext.Provider value={{ userRole }}>{children}</UserContext.Provider>
  );
};
